import React, { Fragment, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import * as wizardSelectors from '@/redux/wizard/selectors';

import CircleLoader from '../CircleLoader';

import styles from './Wizard.module.scss';

import { useBranding, usePreloadMailingLead } from '../../customHooks';

type WizardLayoutT = {
  children: ReactNode;
};

function WizardLayout({ children }: WizardLayoutT) {
  const { loading } = useBranding();
  const { loading: loadingLead } = usePreloadMailingLead();

  const branding = useSelector(wizardSelectors.getBranding);

  if (!!branding?.primary) {
    document.documentElement.style.setProperty('--primary', branding?.primary);
  } else {
    document.documentElement.style.setProperty('--primary', null);
  }

  return (
    <Fragment>
      {loading || loadingLead ? (
        <div className={styles.wizard_layout_container}>
          <CircleLoader size="medium" customClass={styles.loader} />
        </div>
      ) : (
        children
      )}
    </Fragment>
  );
}

export default WizardLayout;
